import type { ImageAOI, ImageAOI_DTO } from '.';
import { CWOImageSource, RemoteSensingImageSource, Source } from '.';

export class ImageAOIHelper {
  static parseSource(source: string): Source {
    switch (source) {
      case RemoteSensingImageSource.SENTINEL:
      case CWOImageSource.SENTINEL_2A:
      case CWOImageSource.SENTINEL_2B:
        return Source.SENTINEL;
      case RemoteSensingImageSource.PLANET:
      case CWOImageSource.PLANET:
      case Source.PLANET:
        return Source.PLANET;
      case RemoteSensingImageSource.DRONE:
        return Source.DRONE;
      default:
        return Source.SENTINEL;
    }
  }

  static parse(input: ImageAOI_DTO): ImageAOI {
    return {
      id: input.id,
      sceneId: input.scenes[0],
      aoi: input.aoi,
      acquiredAt: input.acquired_at,
      fromCompositeImageId: input.from_composite_image_id,
      geojson: input.geojson,
      imageCloudCoverage: input.image_cloud_coverage ?? 0,
      sceneCloudCoverage: input.scene_cloud_coverage ?? 0,
      lastProcessedAt: input.last_processed_at,
      source: this.parseSource(input.source),
      bounds: input.scene_bounds,
      composedOf: {},
      tilePath: input._tile,
      subProducts: input.sub_products,
      stats: input.extra_attributes?.image_metadata?.stats ?? {},
    };
  }
}
